<template>
    <div class="guochanhua-header2">
        <div>
            <img src="@/assets/image/gch.png" alt="" style="width:100%;margin-top: 80px">
        </div>
        <div>
        <div class="header-first5">
              <div style="display:flex;">
                  <div style="margin-left:45px;margin-top:180px">
                      <div style="display:flex">
                          <div style="margin-left:8px">
                              <div style="font-size: 24px;color: #000000;">全国产化架构支持</div>
                              <p style="width: 446px;font-size: 16px;color: #656B90;"><img src="@/assets/image/ling.png" alt="" style="width:13px;height:13px;margin-top:38px"><span style="margin-left:8px">支持国产化主流PC操作系统客户端和芯片</span></p>
                              <p style="width: 446px;font-size: 16px;color: #656B90;"><img src="@/assets/image/ling.png" alt="" style="width:13px;height:13px;margin-top:12px"><span style="margin-left:8px">支持主流国产化服务器操作系统、中间件、数据库和芯片</span></p>
                          </div>
                      </div>
                  </div>
                   <img src="@/assets/image/gch1.png" alt="" style="margin-left:50px;">
              </div>
          </div>
          <div style="background: #EBF3FE;">
            <div class="header-first4">
              <div style="display:flex;">
                <img src="@/assets/image/gch2.png" alt="" style="margin-left:50px;margin-top: 40px;">
                  <div style="margin-left:80px;margin-top:200px">
                      <div style="display:flex">
                          <div style="margin-left:8px">
                              <div style="font-size: 24px;color: #000000;">信创国产化证书</div>
                              <p style="width: 446px;font-size: 16px;color: #656B90;"><img src="@/assets/image/ling.png" alt="" style="width:13px;height:13px;margin-top:38px"><span style="margin-left:8px">与主流的国产操作系统和中间件、数据库厂商完成相互认证</span></p>
                              <p style="width: 446px;font-size: 16px;color: #656B90;"><img src="@/assets/image/ling.png" alt="" style="width:13px;height:13px;margin-top:12px"><span style="margin-left:8px">与主流的国产芯片厂商完成相互认证</span></p>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
        </div>
        <div class="header-first6">
              <div style="display:flex;">
                  <div style="margin-left:45px;margin-top:200px">
                      <div style="display:flex">
                          <div style="margin-left:8px">
                              <div style="font-size: 24px;color: #000000;">与其他平台兼容使用</div>
                              <p style="width: 446px;font-size: 16px;color: #656B90;"><img src="@/assets/image/ling.png" alt="" style="width:13px;height:13px;margin-top:38px"><span style="margin-left:8px">与Windows、Mac、Android、iOS软件端兼容使用</span></p>
                              <p style="width: 446px;font-size: 16px;color: #656B90;"><img src="@/assets/image/ling.png" alt="" style="width:13px;height:13px;margin-top:12px"><span style="margin-left:8px">与硬件视频会议端，H323硬件终端，监控，无人机等终端兼</span></p>
                              <p style="width: 446px;font-size: 16px;color: #656B90;margin-left: 20px;margin-top: 8px;"><span >容使用</span></p>
                          </div>
                      </div>
                  </div>
                   <img src="@/assets/image/gch3.png" alt="" style="margin-left:50px;margin-top:20px;">
              </div>
          </div>
        </div>
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss">
    .guochanhua-header2{
        .header-first3{
            height: s20px;
            width:1200px;
            margin:0 auto;
            margin-top: 30px;
        }
    .header-first4{
            height: 580px;
            width:1200px;
            margin:0 auto;
    }
    .header-first5{
            height: 510px;
            width:1200px;
            margin:0 auto;
            margin-top: 20px;
    }
    .header-first6{
            height: 540px;
            width:1200px;
            margin:0 auto;
            margin-top: 20px;
    }
        width: 100%;
        .header-first{
            height: 710px;
            width:1200px;
            margin:0 auto;
        }
        .header-send{
            height: 690px;
            background: #EBF3FE;
        }
    }
    .gaoliang .liang{
        box-shadow: 0 0 .52083vw rgba(0, 0, 0, .4);
        transition: transform .3s ease;
    }
     .gaoliang .liang:hover{
        background: linear-gradient(0deg, #e4f0ff, #fff) no-repeat !important;
        transform: translateY(-10px); 
    }
    
</style>